<template>
<div>
  <page-navigation :title="`New App`"></page-navigation>  
  <columns>
    <column>
      <p>When creating a new app a sensible default environment is generated for you. Apps can have many environments associated with them. Think of a staging or development environment.
        Once a app is created you may add additional environments to the app.
      </p>
    </column>
  </columns>
  <columns>
    <column>
      <text-input
        description="A unique and descriptive name for your application"
        required
        :value="app.name"
        :error="$root.errorBag.name"
        @input="updateName">
        Name
      </text-input>
    </column>
    <column>
      <text-input
        required
        description="The production URL from where your application is served to the public."
        :value="app.domain"
        @input="updateDomain"
        :error="$root.errorBag.domain">
        URL
      </text-input>
    </column>
  </columns>

  <columns>
    <column>
      <submit-button
        @submit="saveDomain"
        class="is-rounded mt-2"
        :working="working"
        left-icon="save">
        Save
      </submit-button>
    </column>
  </columns>
</div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { getPath } from '@/api/common'

export default {

  data: () => ({
    working: false,
    generate_local_env: true,
    generate_stage_env: true,
    client_id: '',
    client_secret: '',
    test_env_name: 'My development env',
    standards: []
  }),

  beforeCreate() {
    getPath({
      path: '/api/standards-list'
    }, ({data}) => {
      this.standards = data
    })
    this.$store.commit('app/clear')
  },

  created() {
    this.$bus.$emit('set-title', 'New App')
  },

  methods: {
    saveDomain() {
      this.working = true
      this.$store.dispatch('app/storeApp', {
        generate_local_env: this.generate_local_env,
        generate_stage_env: this.generate_stage_env,
      }).then((payload) => {
        this.$router.push({
          name: 'app-setup-keys'
        })
      }).catch(error => {
        this.$toast.error('please try again')
        this.working = false
      })
    },
    ...mapMutations('app', [
      'updateDomain',
      'updateName',
      'updateIpAddress',
      'toggleCreateStageEnv',
      'toggleCreateLocalDevEnv',
      'updateStandards'
    ])
  },

  computed: {
    ...mapGetters('app', [
      'app'
    ])
  }

}
</script>
